import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const issueNavigatorProjectClassicRoute: InvariantJiraRoute = {
	name: 'issue-navigator-classic',
	path: '/jira/software/c/projects/:projectKey/issues/:navigationItemId?',
};
